import React, { Component } from 'react'
import { connect } from 'react-redux'
import { identity, partial } from 'lodash' 
import classNames from 'classnames'
import ReactRedirect from 'react-redirect'

import { getConfirmVM } from 'state/viewModels'
import { Button, ButtonLink, TrackedLink} from "components/Buttons"
import ControlledRadioGroup from 'components/ControlledRadioGroup'
import ControlledTextInput from 'components/ControlledTextInput'
import NavWarning from 'containers/NavWarning'
import * as actions from 'ducks/modules/customize'
import Modal from 'react-modal';
import config from 'util/config.js'
import SpinnerGif from 'images/spinner-32.gif'
//import NavWarning from 'containers/NavWarning'

export class ConfirmForm extends Component {
  constructor(props) {
    super();
    this.state = { 
      addToSavedResult: null, 
      addToCartResult: null, 
      addToCartResultModalIsOpen: false,
      showAuth: !props.auth.valid, 
      showInsurance: !(props.specs.buyAPutter && props.specs.buyAPutter.selected),
      addToCartClicked: false, 
      showSpinner: false,
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.addToSavedHandler = this.addToSavedHandler.bind(this);
  }
  
  addToSavedHandler(){
    this.props.addToSaved().then((result) => {
      this.setState({ addToSavedResult: result.payload });
    })
  }

  setAddToCartClicked(isClicked) {
    this.setState({ addToCartClicked: isClicked });
    this.setShowSpinner(isClicked);
  };

  setShowSpinner(isShowSpinner) {
    this.setState({ showSpinner: isShowSpinner });
  };
  
  openModal() {
    this.setState({addToCartResultModalIsOpen: true});
    this.setShowSpinner(false);
  }
  closeModal() {
    this.setState({addToCartResultModalIsOpen: false});
    this.setAddToCartClicked(false);
  }
  
  render = () => {
    var buttonLabel =  (this.props.instanceIntent === "updateOrder") ? "update" : "add to cart";
    return (<div>
      <div className="customize-form-header">Confirm</div>
      {/*
        <NavWarning when={!this.props.validation.valid}
          message="Please fix the errors below before going to another page" />
      */}
      {this.state.showAuth &&
        <div className="customize-form-section">
            <ControlledRadioGroup
                radioGroup="authentication"
                selected={this.props.auth.selected}
                options={this.props.auth.options}
                showPrice={true}
                isError={false}
                onChange={partial(this.props.onFieldChange, 'authentication')}
            />
            <TrackedLink trackingData="Auth Benefits Link" to="auth">See the benefits of Authenticating your putter</TrackedLink>
        </div>
      }
      <div className={classNames("customize-form-section", {"hidden": !this.state.showInsurance})}> 
          <div className="customize-form-section-header">Insurance Value</div>
          <div className="instructional-text">($3000 max)</div>
          <ControlledTextInput
              value={this.props.insurance.selected}
              //isError={this.props.insurance.valid} // This is throwing an error
              onChange={(v) => { 
                v = v.replace(/\D/g, "");
                if (parseInt(v, 10) > 3000){ v = "3000"; }
                this.props.onInsuranceChange(v);
               }}
              title="Numeric Values Only"
          />
      </div>
      <div className={classNames("customize-form-section", { "customize-form-space-above": this.state.showAuth || this.state.showInsurance })}> 
        {this.props.accessories.buyAPutter.selected &&
          <div>
            <div className="buy-a-putter-price-section">
              <span className="buy-a-putter-label">NEW PUTTER: </span>
              <span className="buy-a-putter-price">${this.props.accessories.buyAPutter.selected.price}</span>
            </div>
            <div className="customize-options-price-section">
              <span className="customize-options-label">CUSTOMIZATIONS: </span>
              <span className="customize-options-price">${this.props.price.total - this.props.accessories.buyAPutter.selected.price}</span>
            </div>
          </div>
        }
        <div className="confirm-total-price">
          <span className="confirm-total">TOTAL: </span>
          <span className="confirm-price">${this.props.price.total}</span>
        </div>
      </div>
      <div className="customize-form-section">
		{!this.props.specs.validation.parts.reshaftLength.valid &&
			<div className="error">You must select Desired Length when Restoration is selected. Please return to Specs and change your Length selection.</div>
		}
		{(this.props.hasPaintfillErrors) &&
			<div className="error">Please select paintfill colors for all highlighted locations.</div>
		}
        {this.props.valid && !this.state.addToCartClicked
          ? <Button className="next" onClick={ ()=> {this.setAddToCartClicked(true); this.props.addToCart().then((result) => { this.setState({addToCartResult: result.payload});this.openModal(); })}}>{buttonLabel}</Button>
          : <Button className="next disabled" onClick={ (e) => e.preventDefault() }>{buttonLabel}</Button>
        }
        <div className="next-spinner-container"><img src={SpinnerGif} alt={'Loading'} className={'next-spinner ' + (this.state.showSpinner ? '' : 'hidden') }/></div>
      </div>
      <Modal className={classNames("customizer modal-popup", 
          /* hide empty popup flash before redirect :  19125 */
          {"hidden": this.state.addToCartResult && this.state.addToCartResult.Success && this.props.instanceIntent !== "updateOrder"}
        )} 
        overlayClassName="modal-overlay"
        isOpen={this.state.addToCartResultModalIsOpen}
        onRequestClose={this.closeModal}
        contentLabel="Add to Cart Result Modal"
        > 
        <div className="close-modal" onClick={this.closeModal}>X</div>
        {(this.state.addToCartResult && this.state.addToCartResult.Success)
            ? (this.props.instanceIntent === "updateOrder" && 
                <div>
                  <div className="min-price-modal-header">Putter Saved</div>
                  <div className="add-to-cart-modal-btns">
                    <ButtonLink to="/findputter">Customize Another Putter</ButtonLink>
                    {this.props.instanceIntent !== "updateOrder" && 
                      <Button href={config.cartUrl}>Checkout</Button>
                    }
                  </div>
                </div>
              )|| 
              <ReactRedirect location={config.cartUrl}></ReactRedirect>
          : <div>
              {!this.state.addToSavedResult &&
                <div>
					<div className="min-price-modal-header">There was a problem adding to cart.</div>
					
					{this.state.addToCartResult == null || this.state.addToCartResult.Errors == null ? '' : this.state.addToCartResult.Errors.map((item, key) =>
						<p>{item.Message}</p>	
					)}
				</div>						
              }
              {this.state.addToSavedResult && this.state.addToSavedResult.Success &&
					<div className="min-price-modal-header">Add to Saved was successful.</div>
              }
              {this.state.addToSavedResult && !this.state.addToSavedResult.Success &&
                <div className="min-price-modal-header">There was a problem saving your instance.</div>
              }
              {(!this.state.addToSavedResult || !this.state.addToSavedResult.Success) &&
              <div className="add-to-cart-modal-btns">
                <Button onClick={this.closeModal}>Close</Button>
                {(window._SC_IS_LOGGED_IN &&
                  <Button onClick={this.addToSavedHandler}>Save Your Putter</Button>
                ) ||
                  <Button href={config.loginUrl + "?r=" + window.location.pathname + "/save"}>Save Your Putter</Button>
                }
              </div>
              }
            </div>
        }
      </Modal>
    </div>
    )
  }
}

ConfirmForm.defaultProps = {
  onFieldChange: identity,
};

const mapStateToProps = (state, ownProps) => {
  var tempProps = {
    instanceIntent : state.customize.instanceIntent,
    ...getConfirmVM(state.customize) 
  }
  tempProps.hasPaintfillErrors = !tempProps.top.validation.parts.paintFillLocations.valid || !tempProps.face.validation.parts.paintFillLocations.valid || !tempProps.back.validation.parts.paintFillLocations.valid;
  
  if(!tempProps.hasPaintfillErrors)
  {
	  if(tempProps.face.initials.length > 0 || tempProps.back.initials.length > 0) {
		  var allInitials = tempProps.face.initials.concat(tempProps.back.initials);
		  for(var y = 0; y < allInitials.length; y++)
		  {
			  var i = allInitials[y];
			  if(i.selected != undefined && i.selected.enabled) {
				  if(!i.paint.valid) {
					tempProps.hasPaintfillErrors = true;
					break;
				  }
			  }
		  }
	  }
  }
  
  if(!tempProps.hasPaintfillErrors)
  {
	  if(tempProps.face.stampsLocations.length > 0 || tempProps.back.stampsLocations.length > 0) {
		  var allStamps = tempProps.face.stampsLocations.concat(tempProps.back.stampsLocations);
		  for(var x = 0; x < allStamps.length; x++)
		  {
			  var stamp = allStamps[x];
			  if(stamp.selected != undefined && stamp.selected.enabled) {
				  if(!stamp.paint.valid) {
					tempProps.hasPaintfillErrors = true;
					break;
				  }
			  }
		  }
	  }
  }
  
  if(!tempProps.hasPaintfillErrors)
  {
	  if(tempProps.top.flangeLines.selected && tempProps.top.flangeLines.selected.numberOfLines > 0) {
		  if(tempProps.top.flangeLines.paints != undefined && tempProps.top.flangeLines.paints.length > 0) {
			  if(!tempProps.top.flangeLines.paints[0].valid ) {
				tempProps.hasPaintfillErrors = true;
			  }
		  }
	  }
  }
  
  if(!tempProps.hasPaintfillErrors)
  {
	  
	  if((tempProps.top.topLines.selected && tempProps.top.topLines.selected.numberOfLines > 0) ||
	  (tempProps.top.sightDots.selected && tempProps.top.sightDots.selected.numberOfLines > 0)) {
		  var topDotLines = tempProps.top.topLines.selected ? tempProps.top.topLines : tempProps.top.sightDots;
		  if(topDotLines.paints != undefined && topDotLines.paints.length > 0) {
			  if(!topDotLines.paints[0].valid) {
				tempProps.hasPaintfillErrors = true;
			  }
		  }
	  }
  }
  
  return tempProps;
}

const mapDispatchToProps = {
  addToCart : actions.addToCart,
  addToSaved : actions.addToSaved,
  onFieldChange: actions.selectField,
  onInsuranceChange: partial(actions.setFieldValue, 'insuranceValue'),
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmForm);

